(function () {
  var SUPABASE_URL = 'https://xpjjvrjcjouylartupwy.supabase.co';
  var FALLBACK_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inhwamp2cmpjam91eWxhcnR1cHd5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk3MzQ3MTEsImV4cCI6MjA2NTMxMDcxMX0.OYbFjEfyO4IspmLKW8W9yqre-46GiqobE22yO7aUvLM';

  var POSITION_TITLES = {
    barista: 'Barista',
    bakery: 'Bakery Staff',
    delivery: 'Delivery Driver',
    roastery: 'Roastery Team',
  };

  var FOOD_HANDLER_ROLES = { barista: true, bakery: true, roastery: true };

  var ESSENTIAL_FUNCTIONS = {
    barista: 'Barista: This role involves standing for extended periods, repetitive hand motions, and lifting up to 30 lbs.',
    bakery: 'Bakery Staff: This role involves standing for extended periods, lifting up to 50 lbs, working in warm environments near commercial ovens, and early morning starts as early as 4–5 AM.',
    delivery: 'Delivery Driver: This role involves driving for extended periods, loading and unloading products, lifting up to 50 lbs repeatedly throughout the day, and working in varying weather conditions.',
    roastery: 'Roastery Team: This role involves standing for extended periods, working in warm environments near commercial roasters, lifting green coffee bags up to 70 lbs, and early morning starts.',
  };

  var DAY_LABELS = {
    monday: 'Mon', tuesday: 'Tue', wednesday: 'Wed', thursday: 'Thu',
    friday: 'Fri', saturday: 'Sat', sunday: 'Sun',
  };

  function ynValue(raw) {
    if (raw === 'yes') return true;
    if (raw === 'no') return false;
    return null;
  }

  function readMeta(name) {
    var el = document.querySelector('meta[name="' + name + '"]');
    return el ? el.getAttribute('content') || '' : '';
  }

  function resolveAnonKey(form) {
    return (
      form.getAttribute('data-supabase-anon-key') ||
      document.body.getAttribute('data-supabase-anon-key') ||
      readMeta('supabase-anon-key') ||
      FALLBACK_ANON_KEY ||
      ''
    );
  }

  function setMessage(form, text, isError) {
    var msg = form.querySelector('[data-careers-form-message]');
    if (!msg) return;
    msg.textContent = text;
    msg.classList.add('is-visible');
    msg.classList.toggle('is-error', !!isError);
  }

  function toggleDetails(select, detailsBlock, detailsField) {
    if (!select || !detailsBlock) return;
    var show = select.value === 'yes';
    detailsBlock.hidden = !show;
    if (detailsField) detailsField.required = show;
    if (!show && detailsField) detailsField.value = '';
  }

  function getSelectedPositions(form) {
    return Array.prototype.slice.call(form.querySelectorAll('[data-position-checkbox]:checked'))
      .map(function (el) { return el.value; })
      .filter(Boolean);
  }

  function positionsInclude(positions, slug) {
    return positions.indexOf(slug) !== -1;
  }

  function needsFoodHandler(positions) {
    return positions.some(function (p) { return !!FOOD_HANDLER_ROLES[p]; });
  }

  function buildEssentialText(positions) {
    var parts = positions.map(function (p) { return ESSENTIAL_FUNCTIONS[p]; }).filter(Boolean);
    if (!parts.length) return '';
    return parts.join(' ') + ' Are you able to perform these essential functions with or without reasonable accommodation?';
  }

  function syncPreferredOptions(form, positions) {
    var block = form.querySelector('[data-preferred-role-block]');
    var select = form.querySelector('[data-preferred-position-select]');
    if (!block || !select) return;
    var current = select.value;
    select.innerHTML = '<option value="">Select your preferred role…</option>';
    positions.forEach(function (p) {
      var opt = document.createElement('option');
      opt.value = p;
      opt.textContent = POSITION_TITLES[p] || p;
      select.appendChild(opt);
    });
    block.hidden = positions.length < 2;
    select.required = positions.length >= 2;
    if (current && positions.indexOf(current) !== -1) {
      select.value = current;
    } else if (positions.length === 1) {
      select.value = positions[0];
    }
  }

  function applyPositionsUI(form, positions) {
    form.querySelectorAll('[data-role-only]').forEach(function (el) {
      var roles = (el.getAttribute('data-role-only') || '').split(',');
      var show = roles.some(function (r) { return positionsInclude(positions, r.trim()); });
      el.hidden = !show;
    });

    var barista = positionsInclude(positions, 'barista');
    var bakery = positionsInclude(positions, 'bakery');
    var delivery = positionsInclude(positions, 'delivery');
    var roastery = positionsInclude(positions, 'roastery');

    var setReq = function (name, req) {
      var el = form.querySelector('[name="' + name + '"]');
      if (el) el.required = !!req;
    };

    setReq('primary_location', barista);
    setReq('open_to_other_locations', barista);
    setReq('coffee_experience', barista);
    setReq('weekend_available', barista);
    setReq('hospitality', barista);

    setReq('baking_experience', bakery);
    setReq('bakery_early_morning', bakery);
    setReq('saturday_production', bakery);
    setReq('batch_lists', bakery);

    setReq('valid_license', delivery);
    setReq('reliable_transport', delivery);
    setReq('driving_experience', delivery);
    setReq('weather_loading', delivery);
    setReq('early_morning_routes', delivery);

    setReq('production_experience', roastery);
    setReq('roastery_early_morning', roastery);
    setReq('heavy_lifting', roastery);
    setReq('roasting_interest', roastery);

    var foodBlock = form.querySelector('[data-food-handler-block]');
    var foodInput = form.querySelector('[name="food_handler_ok"]');
    var needsFood = needsFoodHandler(positions);
    if (foodBlock) foodBlock.hidden = !needsFood;
    if (foodInput) foodInput.required = needsFood;

    var essentialEl = form.querySelector('[data-label-essential]');
    if (essentialEl) essentialEl.textContent = buildEssentialText(positions);

    var hintEl = form.querySelector('[data-availability-hint]');
    if (hintEl) {
      var hasCafe = barista;
      var hasEarly = bakery || delivery || roastery;
      if (hasCafe && hasEarly) {
        hintEl.textContent = 'Cafe hours: Mon–Sat 6:30am–6pm (Sunday varies). Bakery, delivery, and roastery roles often start 4–6am.';
      } else if (hasEarly) {
        hintEl.textContent = 'These roles often start as early as 4–6am. Use custom times if needed.';
      } else {
        hintEl.textContent = 'Store hours: Mon–Sat 6:30am–6pm; Sunday hours vary by location.';
      }
    }

    toggleDetails(form.querySelector('[name="coffee_experience"]'), form.querySelector('[data-coffee-details]'), form.querySelector('[name="coffee_experience_details"]'));
    toggleDetails(form.querySelector('[name="baking_experience"]'), form.querySelector('[data-baking-details]'), form.querySelector('[name="baking_experience_details"]'));
    toggleDetails(form.querySelector('[name="driving_experience"]'), form.querySelector('[data-driving-details]'), form.querySelector('[name="driving_experience_details"]'));
    toggleDetails(form.querySelector('[name="production_experience"]'), form.querySelector('[data-production-details]'), form.querySelector('[name="production_experience_details"]'));

    syncPreferredOptions(form, positions);
  }

  function bindAvailability(form) {
    form.querySelectorAll('[data-availability-day]').forEach(function (select) {
      select.addEventListener('change', function () {
        var day = select.getAttribute('data-availability-day');
        var times = form.querySelector('[data-availability-times="' + day + '"]');
        if (!times) return;
        var inputs = times.querySelectorAll('input');
        if (select.value === 'custom') {
          times.hidden = false;
          inputs.forEach(function (inp) { inp.disabled = false; });
        } else {
          times.hidden = true;
          inputs.forEach(function (inp) { inp.disabled = true; inp.value = ''; });
        }
      });
    });
  }

  function collectAvailability(form) {
    var data = { timezone: Intl.DateTimeFormat().resolvedOptions().timeZone, days: {} };
    var parts = [];
    Object.keys(DAY_LABELS).forEach(function (day) {
      var status = (form.querySelector('[name="availability_' + day + '"]') || {}).value || 'not_available';
      var start = (form.querySelector('[name="availability_' + day + '_start"]') || {}).value || '';
      var end = (form.querySelector('[name="availability_' + day + '_end"]') || {}).value || '';
      var dayData = { status: status };
      if (status === 'all_day') {
        dayData.start = '06:30';
        dayData.end = '18:00';
        parts.push(DAY_LABELS[day] + ': 6:30am-6:00pm');
      } else if (status === 'custom') {
        if (start && end) {
          dayData.start = start;
          dayData.end = end;
          parts.push(DAY_LABELS[day] + ': ' + start + '-' + end);
        } else {
          parts.push(DAY_LABELS[day] + ': Custom (times required)');
        }
      } else {
        parts.push(DAY_LABELS[day] + ': Not available');
      }
      data.days[day] = dayData;
    });
    return { data: data, summary: parts.join('; ') };
  }

  function buildExperienceSummary(positions, answers) {
    var parts = [];
    if (positionsInclude(positions, 'barista')) {
      parts.push('Barista/cafe: ' + (answers.coffee_experience ? 'Yes' : 'No'));
      if (answers.coffee_experience_details) parts.push(answers.coffee_experience_details);
    }
    if (positionsInclude(positions, 'bakery')) {
      parts.push('Bakery/kitchen: ' + (answers.baking_experience ? 'Yes' : 'No'));
      if (answers.baking_experience_details) parts.push(answers.baking_experience_details);
    }
    if (positionsInclude(positions, 'delivery')) {
      parts.push('Delivery/driving: ' + (answers.driving_experience ? 'Yes' : 'No'));
      if (answers.driving_experience_details) parts.push(answers.driving_experience_details);
    }
    if (positionsInclude(positions, 'roastery')) {
      parts.push('Roasting/production: ' + (answers.production_experience ? 'Yes' : 'No'));
      if (answers.production_experience_details) parts.push(answers.production_experience_details);
    }
    return parts.join('\n');
  }

  function validateCustomAvailabilityTimes(form) {
    var missing = [];
    Object.keys(DAY_LABELS).forEach(function (day) {
      var statusEl = form.querySelector('[name="availability_' + day + '"]');
      var status = statusEl ? statusEl.value : '';
      if (status !== 'custom') return;
      var start = (form.querySelector('[name="availability_' + day + '_start"]') || {}).value || '';
      var end = (form.querySelector('[name="availability_' + day + '_end"]') || {}).value || '';
      if (!start || !end) missing.push(DAY_LABELS[day]);
    });
    return missing;
  }

  function preferredPosition(positions, explicit) {
    if (explicit && positions.indexOf(explicit) !== -1) return explicit;
    return positions[0] || '';
  }

  function buildPayload(form) {
    var fd = new FormData(form);
    var availability = collectAvailability(form);
    var positions = getSelectedPositions(form);
    var preferred = preferredPosition(positions, String(fd.get('preferred_position') || '').trim());

    var answers = {
      age_18_or_older: ynValue(fd.get('age_18_or_older')),
      visited_black_elm: String(fd.get('visited_black_elm') || '').trim(),
      primary_location: String(fd.get('primary_location') || '').trim() || null,
      open_to_other_locations: ynValue(fd.get('open_to_other_locations')),
      coffee_experience: ynValue(fd.get('coffee_experience')),
      coffee_experience_details: String(fd.get('coffee_experience_details') || '').trim() || null,
      weekend_available: ynValue(fd.get('weekend_available')),
      hospitality: String(fd.get('hospitality') || '').trim() || null,
      baking_experience: ynValue(fd.get('baking_experience')),
      baking_experience_details: String(fd.get('baking_experience_details') || '').trim() || null,
      bakery_early_morning: ynValue(fd.get('bakery_early_morning')),
      saturday_production: ynValue(fd.get('saturday_production')),
      batch_lists: ynValue(fd.get('batch_lists')),
      valid_license: ynValue(fd.get('valid_license')),
      reliable_transport: ynValue(fd.get('reliable_transport')),
      driving_experience: ynValue(fd.get('driving_experience')),
      driving_experience_details: String(fd.get('driving_experience_details') || '').trim() || null,
      weather_loading: ynValue(fd.get('weather_loading')),
      early_morning_routes: ynValue(fd.get('early_morning_routes')),
      production_experience: ynValue(fd.get('production_experience')),
      production_experience_details: String(fd.get('production_experience_details') || '').trim() || null,
      roastery_early_morning: ynValue(fd.get('roastery_early_morning')),
      heavy_lifting: ynValue(fd.get('heavy_lifting')),
      roasting_interest: String(fd.get('roasting_interest') || '').trim() || null,
      employment_type: String(fd.get('employment_type') || '').trim() || null,
      shifts_per_week: String(fd.get('shifts_per_week') || '').trim() || null,
      store_preference: String(fd.get('primary_location') || '').trim() || null,
      schedule_commitment: fd.get('schedule_commitment') === 'on',
      essential_functions_ok: fd.get('essential_functions_ok') === 'on',
      food_handler_ok: fd.get('food_handler_ok') === 'on',
      drug_free_ok: fd.get('drug_free_ok') === 'on',
      background_check_ok: fd.get('background_check_ok') === 'on',
      at_will_ok: fd.get('at_will_ok') === 'on',
      availability_notes: String(fd.get('availability_notes') || '').trim() || null,
      anything_else: String(fd.get('anything_else') || '').trim() || null,
    };

    answers.interest = answers.visited_black_elm;
    answers.experience = buildExperienceSummary(positions, answers);

    return {
      name: String(fd.get('name') || '').trim(),
      email: String(fd.get('email') || '').trim().toLowerCase(),
      phone: String(fd.get('phone') || '').trim(),
      password: String(fd.get('password') || '').trim(),
      positions: positions,
      position: preferred,
      availability_grid: availability.data,
      availability_text: availability.summary,
      answers: answers,
      surface: 'shopify_careers',
    };
  }

  function bindForm(form) {
    var positionsWarn = form.querySelector('[data-positions-warning]');

    function refreshPositions() {
      var positions = getSelectedPositions(form);
      if (positionsWarn) positionsWarn.hidden = positions.length > 0;
      applyPositionsUI(form, positions);
    }

    form.querySelectorAll('[data-position-checkbox]').forEach(function (cb) {
      cb.addEventListener('change', refreshPositions);
    });

    [
      ['coffee_experience', 'data-coffee-details', 'coffee_experience_details'],
      ['baking_experience', 'data-baking-details', 'baking_experience_details'],
      ['driving_experience', 'data-driving-details', 'driving_experience_details'],
      ['production_experience', 'data-production-details', 'production_experience_details'],
    ].forEach(function (cfg) {
      var select = form.querySelector('[name="' + cfg[0] + '"]');
      if (!select) return;
      select.addEventListener('change', function () {
        toggleDetails(select, form.querySelector('[' + cfg[1] + ']'), form.querySelector('[name="' + cfg[2] + '"]'));
      });
    });

    var licenseSelect = form.querySelector('[name="valid_license"]');
    var licenseWarn = form.querySelector('[data-license-warning]');
    if (licenseSelect && licenseWarn) {
      licenseSelect.addEventListener('change', function () {
        licenseWarn.hidden = licenseSelect.value !== 'no';
      });
    }

    var ageSelect = form.querySelector('[name="age_18_or_older"]');
    var ageWarn = form.querySelector('[data-age-warning]');
    if (ageSelect && ageWarn) {
      ageSelect.addEventListener('change', function () {
        ageWarn.hidden = ageSelect.value !== 'no';
      });
    }

    bindAvailability(form);
    refreshPositions();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var anon = resolveAnonKey(form);
      if (!anon) {
        setMessage(form, 'Configuration error — please email careers@blackelm.coffee.', true);
        return;
      }

      var positions = getSelectedPositions(form);
      if (!positions.length) {
        if (positionsWarn) positionsWarn.hidden = false;
        setMessage(form, 'Please select at least one role.', true);
        return;
      }

      var missingTimes = validateCustomAvailabilityTimes(form);
      if (missingTimes.length) {
        setMessage(form, 'Please enter start and end times for custom availability: ' + missingTimes.join(', ') + '.', true);
        return;
      }

      var payload = buildPayload(form);
      if (payload.answers.age_18_or_older !== true) {
        setMessage(form, 'Black Elm Coffee only hires people who are 18 or older.', true);
        return;
      }

      var submitBtn = form.querySelector('[type="submit"]');
      var defaultLabel = submitBtn ? (submitBtn.getAttribute('data-default-label') || submitBtn.textContent) : 'Submit';

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting…';
      }

      fetch(SUPABASE_URL + '/functions/v1/submit-applicant-application', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + anon,
          apikey: anon,
        },
        body: JSON.stringify(payload),
      })
        .then(function (resp) {
          return resp.json().then(function (data) {
            return { ok: resp.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok || !result.data || !result.data.success) {
            var details = (result.data && result.data.details) ? result.data.details.join(' ') : '';
            throw new Error((result.data && result.data.error) || details || 'submit_failed');
          }

          form.hidden = true;
          var success = document.querySelector('[data-careers-success]');
          if (success) {
            success.hidden = false;
            var emailEl = success.querySelector('[data-success-email]');
            var passEl = success.querySelector('[data-success-password]');
            var portalLink = success.querySelector('[data-success-portal-link]');
            if (emailEl) emailEl.textContent = payload.email;
            if (passEl) passEl.textContent = payload.password;
            if (portalLink && result.data.portal_url) portalLink.href = result.data.portal_url;
          }
        })
        .catch(function (err) {
          setMessage(form, 'Something went wrong: ' + (err.message || 'please try again or email careers@blackelm.coffee.'), true);
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = defaultLabel;
          }
        });
    });
  }

  function init() {
    document.querySelectorAll('[data-careers-application-form]').forEach(bindForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
